export const QUERY_PARAM_CURRENT_TEAM_ID = 'currentTeamId';
